/** @jsxImportSource @emotion/react */
import { Field, useField } from 'react-final-form';
import * as validations from '../../../customFields/validations';

/**
 * I really hate that I needed to make a seperate component for this,
 * but we need the 'useField' hook, which can only be used inside a
 * <Form> component.
 */

interface Props {
  label: string;
  name: string;
  type?: string;
  css?: React.CSSProperties;
  onChange?: any;
}

/**
 *
 * @param label the label for the input
 * @param name name of the input field (also the key for the form values object)
 * @param type (optional) the type of input
 * @param css (optional) css override
 */
const CardNumberField = ({
  label,
  name,
  type = 'text',
  css = null,
  onChange = null,
}: Props) => {
  const formatCardNumber = (val: string) => {
    return val?.length ? val.replaceAll(' ', '').replaceAll('-', '') : '';
  };
  return (
    <Field
      name={name}
      component='input'
      type={type}
      validate={(value) => validations.validateCardNumber(value)}
      format={formatCardNumber}
    >
      {({ input, meta }) => {
        return (
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'center',
              width: '100%',
              padding: `8px 0`,
              ...(css ? { ...css } : {}),
            }}
          >
            <div
              css={{
                fontSize: '15px',
                lineHeight: '15px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <p css={{ marginBottom: '12px' }}>{label}</p>
            </div>

            <input
              onInput={onChange}
              id='card-input-mocha'
              {...input}
              type='text'
              style={{ fontSize: '16px' }}
              css={{
                height: '27px', 
                width: '100%',
                ...((meta.error || meta.submitError) && meta.touched
                  ? { outline: '1px solid #f15d22', background: '#ffe9e0' }
                  : {}),
              }}
            />
            <div
              css={{
                height: '12px',
                lineHeight: '12px',
                margin: '2px',
              }}
            >
              {(meta.error || meta.submitError) && meta.touched ? (
                <p
                  id='error-message-mocha'
                  css={{
                    color: '#f15d22',
                    fontSize: '12px',
                  }}
                >
                  {meta.error || meta.submitError}
                </p>
              ) : null}
            </div>
          </div>
        );
      }}
    </Field>
  );
};

export default CardNumberField;
